import { render, staticRenderFns } from "./InventorySalesDescriptionComponent.vue?vue&type=template&id=adb5b330&scoped=true"
import script from "./InventorySalesDescriptionComponent.vue?vue&type=script&lang=js"
export * from "./InventorySalesDescriptionComponent.vue?vue&type=script&lang=js"
import "./InventorySalesDescriptionComponent.vue?vue&type=style&index=0&id=adb5b330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb5b330",
  null
  
)

export default component.exports